import React, { PropTypes } from 'react';
// Components
import Header from '../header/Header';
import MainContainer from '../../../containers/MainContainer';
import Footer from '../footer/Footer';
import MenuTogglerContainer from '../.././../containers/MenuTogglerContainer';
import ads from '../ads';


const { BackgroundLeft, BackgroundRight, Billboard } = ads;

const propTypes = {
  children: PropTypes.node,
  locale: PropTypes.string,
};

const Body = (props) => {
  const { children, locale } = props;

  return (
    <div className="ui body stackable grid">
      <div className="main row">
        <BackgroundLeft locale={locale} />
        <div className="ten wide computer sixteen wide tablet column">
          <div className="ui main stackable grid">
            <Billboard locale={locale} />
            <MenuTogglerContainer />
            <Header />
            <MainContainer>
              {children}
            </MainContainer>
          </div>
        </div>
        <BackgroundRight locale={locale} />
      </div>
      <Footer />
    </div>
  );
};

Body.propTypes = propTypes;

export default Body;



/** WEBPACK FOOTER **
 ** ./src/components/layout/body/Body.js
 **/